'use client';

import React from 'react';

import styles from './StatCard.module.css';

interface StatCardProps {
  label: string;
  value: string;
  icon?: React.ReactNode;
  isLoading?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, icon, isLoading }) => {
  return (
    <div className={ styles.card }>
      { icon && <div className={ styles.icon }>{ icon }</div> }
      <div className={ styles.content }>
        { isLoading ? (
          <div className={ styles.skeleton } style={{ width: '5rem', height: '1.25rem' }} />
        ) : (
          <span className={ styles.value }>{ value }</span>
        ) }
        <span className={ styles.label }>{ label }</span>
      </div>
    </div>
  );
};

export default StatCard;
